import React, { useState, useEffect } from "react";
import {
  Page,
  Card,
  Layout,
  FormLayout,
  Select,
  Button,
  Banner,
  Spinner,
} from "@shopify/polaris";
import axios from "../axiosInstance";

export default function CommissionReport() {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear.toString());
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({ error: false, message: "" });
  const [yearsOptions, setYearsOptions] = useState([]);

  useEffect(() => {
    const options = [];
    for (let y = currentYear; y >= 2020; y--) {
      options.push({ label: y.toString(), value: y.toString() });
    }
    setYearsOptions(options);
  }, [currentYear]);

  const handleGenerateReport = async () => {
    setLoading(true);
    setStatus({ error: false, message: "" });

    try {
      const response = await axios.post("/api/commissions/report", {
        year: parseInt(year),
      });

      if (response.data.status) {
        setStatus({ error: false, message: response.data.msg });
      } else {
        setStatus({
          error: true,
          message: response.data.msg || "Failed to initiate report generation.",
        });
      }
    } catch (error) {
      console.error("Error generating commission report:", error);
      const errorMsg =
        error.response?.data?.msg ||
        error.message ||
        "An unexpected error occurred.";
      setStatus({ error: true, message: errorMsg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Page breadcrumbs={[{ url: "/" }]} title="Commission Report" fullWidth>
      <Layout>
        <Layout.Section>
          <Card sectioned>
            <FormLayout>
              <Select
                label="Select Year"
                options={yearsOptions}
                onChange={(value) => setYear(value)}
                value={year}
                disabled={loading}
              />
              <Button
                primary
                onClick={handleGenerateReport}
                loading={loading}
                disabled={loading}
              >
                Generate Report
              </Button>
            </FormLayout>
          </Card>
        </Layout.Section>

        {status.message && (
          <Layout.Section>
            <Banner
              title={status.error ? "Error" : "Success"}
              status={status.error ? "critical" : "success"}
            >
              <p>{status.message}</p>
            </Banner>
          </Layout.Section>
        )}

        {loading && (
          <Layout.Section>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Spinner size="large" accessibilityLabel="Generating report..." />
              <span style={{ marginLeft: "10px" }}>
                Processing can take a few minutes...
              </span>
            </div>
          </Layout.Section>
        )}
      </Layout>
    </Page>
  );
}
